import { type AgreementAccess } from "$apis/parkito2/index.ts";
import { AgreementModel } from "./mod.ts";
export default class AgreementAccessModel {
  constructor(private data: AgreementAccess) {
  }

  get agreement(): AgreementModel {
    return new AgreementModel(this.data.agreement);
  }
  get accessLevel() {
    return this.data.accessLevel;
  }
}
